import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { modalActions } from '@/stores/action/widget.action';
import ChangePass from './ChangePass';
import ChangePin from './ChangePin';
import Inquiry from './Inquiry';
import InquiryWhite from './InquiryWrite';
import { getLocaleWordContent } from '@/utils/language.util';

function MyInfor({ mymode, ModalActions }) {
    console.log(mymode.mode);
    const handleOpenModal = (e) => {
        ModalActions.showModalEx({ mode: 3 });
    };
    return (
        <>
            <div className="bg_balance_left">
                {mymode.mode === 3 ? <Inquiry ModalActions={ModalActions} /> : <div />}
                {mymode.mode === 4 ? <InquiryWhite ModalActions={ModalActions} /> : <div />}
                <div className="inner">
                    <button className="b_orange btn02" onClick={handleOpenModal}>
                        1:1 {getLocaleWordContent('문의')} 
                    </button>
                </div>
                <div className="sp25"></div>
                <div className="log_box">
                    <ChangePass />
                    <div className="sp15"></div>
                    <hr />
                    <ChangePin />
                </div>
            </div>
        </>
    );
}
export default connect(
    (state) => ({
        mymode: state.widget.getIn(['modalEx', 'mode']),
    }),
    (dispatch) => ({
        ModalActions: bindActionCreators(modalActions, dispatch),
    }),
)(MyInfor);
